export default {
  dishName: 'Dish Name',
  count: 'Count',
  noProvidersHeader: 'No Providers!',
  noProvidersBody: 'Selected days do not have any providers.',
  total: 'Total',
  confirmPayment: 'Confirm Payment',
  undoPayment: 'Undo Payment',
  paidCheckboxLabel: 'Paid for provider',
  paidStatusChangedBy: 'Paid status changed by:',
  markProviderPaid: 'Are you sure you want to pay {total} € for provider \'{providerName}\' for {date}?',
  markProviderNotPaid: 'Are you sure you want to undo {total} € payment for provider \'{providerName}\' for {date}?',
  paidCheckBoxTooltip: 'Provider paid status can not be changed if it is still available for ordering.',
  includeFreeOfCharge: 'Include free of charge days',
  date: 'Date',
  markAllDaysAsPaid: 'Mark all days as paid',
  markAllDaysAsPaidAllPaidTooltip: 'All days are already marked as paid',
  markAllDaysAsPaidStillOrderingTooltip: 'Some day providers are still available for ordering',
  freeOfChargeTooltip: 'Free of charge days can not be marked as paid',
  zeroCostTooltip: '0 € amount can not be marked as paid',
};
